// A tiny stack of "back interceptors" so transient UI (an open menu, sheet,
// lightbox…) can consume the Android hardware-back press BEFORE useAndroidBack
// navigates or minimizes. Each interceptor returns true if it handled the press
// (e.g. closed itself). The most-recently-registered interceptor runs first.
//
// Web/desktop are unaffected — only useAndroidBack (native) consults this.

type BackInterceptor = () => boolean;

const stack: BackInterceptor[] = [];

/** Register an interceptor; returns an unregister fn (call on unmount). */
export function pushBackInterceptor(fn: BackInterceptor): () => void {
  stack.push(fn);
  return () => {
    const i = stack.indexOf(fn);
    if (i >= 0) stack.splice(i, 1);
  };
}

/** Run interceptors top-down; stop at the first that consumes the press.
 *  Returns true if some interceptor handled it (caller should NOT navigate). */
export function runBackInterceptors(): boolean {
  for (let i = stack.length - 1; i >= 0; i--) {
    if (stack[i]!()) return true;
  }
  return false;
}
